module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image47.f57fff34.webp";